import styled from 'styled-components';
import { Text } from '@make-software/tg-mini-app-ui';

export const StyledBodyText = styled(Text)(({ theme }) => ({
  color: theme.colors.lightGray
}));
